import { ungzip } from 'pako';
import { ungzipStream } from './ungzipStream';
/**
 * Some files in the fileCollectionItems may actually be gzip. This method will ungzip those files.
 * The method will actually not really ungzip the files but decompress them if you need.
 * During this process the extension .gz will be removed
 * @param fileCollectionItems
 * @param options
 * @returns
 */
export async function fileCollectionItemsUngzip(fileCollectionItems, options = {}) {
    let { gzipExtensions = ['gz'] } = options;
    gzipExtensions = gzipExtensions.map((extension) => extension.toLowerCase());
    fileCollectionItems = fileCollectionItems.slice(0);
    for (let i = 0; i < fileCollectionItems.length; i++) {
        const file = fileCollectionItems[i];
        const extension = file.name.replace(/^.*\./, '').toLowerCase();
        if (!gzipExtensions.includes(extension)) {
            continue;
        }
        if (!(await isGzip(file))) {
            continue;
        }
        fileCollectionItems.push({
            name: file.name.replace(/\.[^.]+$/, ''),
            size: file.size,
            relativePath: file.relativePath,
            lastModified: file.lastModified,
            text: () => {
                return file.arrayBuffer().then((arrayBuffer) => {
                    const decoder = new TextDecoder('utf8');
                    return decoder.decode(ungzip(new Uint8Array(arrayBuffer)));
                });
            },
            arrayBuffer: () => {
                return file
                    .arrayBuffer()
                    .then((arrayBuffer) => ungzip(new Uint8Array(arrayBuffer)));
            },
            //@ts-expect-error todo should be fixed
            stream: () => {
                return ungzipStream(file);
            },
        });
        fileCollectionItems.splice(i, 1);
        i--;
    }
    return fileCollectionItems.sort((a, b) => a.relativePath < b.relativePath ? -1 : 1);
}
async function isGzip(file) {
    const buffer = await file.arrayBuffer();
    if (buffer.byteLength < 2)
        return false;
    const bytes = new Uint8Array(buffer);
    return bytes[0] === 0x1f && bytes[1] === 0x8b;
}
//# sourceMappingURL=fileCollectionItemsUngzip.js.map